import React, { useEffect, useState } from 'react'
import { Helmet } from "react-helmet"

import { useLocation } from 'react-router-dom'

import Exit from '../Components/Exit'
import WebProjectWindow from '../Components/WebProjectWindow'
import AppProjectWindow from '../Components/AppProjectWindow'
import MlAiProjectWindow from '../Components/MLAiProjectWindow'
import UnityServe from '../Components/projectitems/UnityServe'
import VentureUp from '../Components/projectitems/VentureUp'
import XenithGoods from '../Components/projectitems/XenithGoods'
import WeatherForecast from '../Components/projectitems/WeatherForecast'
import FirebaseLogin from '../Components/projectitems/FirebaseLogin'
import AiChatBot from '../Components/projectitems/AiChatBot'
import FlappyBird from '../Components/projectitems/FlappyBird'
import TextClassification from '../Components/projectitems/TextClassification'
import RealtimeTFOD from '../Components/projectitems/Realtime-TFOD'
import FacialRecognition from '../Components/projectitems/FacialRecognition'
import BillingSystem from '../Components/projectitems/BillingSystem'
import YoutubeAnalyzer from '../Components/projectitems/YoutubeAnalyzer'

const Projects = () => {

    const location = useLocation()

    const isWebDevPage = location.hash.includes('webdev') || location.hash === '' || location.hash === '#All-Projects';
    const isAppDevPage = location.hash.includes('appdev');
    const isMLAiDevPage = location.hash.includes('ml-ai');

    useEffect(() => {
        document.title = 'AmanChauhan-Work'
    }, [])

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loader = document.getElementById("preloader");

        const handleLoad = () => {
            setTimeout(() => {
                setLoading(false);
            }, 1000);
            if (loader) {
                loader.style.display = "none";
            }
        };

        const isMobile = window.innerWidth <= 840;

        if (isMobile) {
            handleLoad();  // Directly call handleLoad for mobile devices
        } else if (document.readyState === 'complete') {
            // If the document is already loaded, call handleLoad immediately
            handleLoad();
        } else {
            window.addEventListener("load", handleLoad);
        }

        return () => {
            window.removeEventListener("load", handleLoad);
        };
    }, []); // Empty dependency array means this effect runs once on component mount

    useEffect(() => {
        const loadScript = (src) => {
            const script = document.createElement('script');
            script.src = src;
            script.async = true; // Ensure the script loads asynchronously
            document.body.appendChild(script);
            return () => document.body.removeChild(script);
        };

        let Scripts;
        if (isWebDevPage || isMLAiDevPage) {
            Scripts = [
                loadScript('../Js/Projects.js'),
                loadScript('../Js/ProjectInfo.js'),
            ];
        }
        return () => Scripts?.forEach(cleanup => cleanup());
    }, [isWebDevPage, isMLAiDevPage]);


    return (
        <>

            {loading ? (
                <div id="preloader" className='preloader'>
                    <img src="../IMG/Aman.png" className='preload-img' alt="AMAN CHAUHAN" />
                    <h2 className='preload-heading'>AMAN CHAUHAN</h2>
                </div>
            ) :
                <>
                    <div className="viewproject display-none"></div>
                    <div className="Next display-none"></div>
                    <div className="Prev display-none"></div>

                    <section id="Projects">
                        <div className="Projects--intro" data-aos="fade-up" data-aos-duration="1000">
                            <p className="text-center mx-4">What I've been up to.</p>
                            <p className="text-center">Here is a selection of projects that I've worked on.</p>
                            <a href="#All-Projects"><i className="fa-solid fa-angle-down fa-2xl"></i></a>
                        </div>
                        <div id="All-Projects">
                            <ul className="Project--Tags" data-aos="fade-right" data-aos-duration="800">
                                <li><a href="#webdev">Web-Dev</a></li>
                                <li><a href="#appdev" className='me-3'>App-Dev</a></li>
                                <li><a href="#ml-ai" className='me-3'>ML-AI</a></li>
                            </ul>

                            <div className="All-Projects">
                                {isWebDevPage && (<>
                                    <WebProjectWindow title="XenithGoods" description="FullStack Development" img="../IMG/XenithGoods.png" />
                                    <WebProjectWindow title="Billing System" description="Desktop Application Built with Java Swing" img="../IMG/BillingSystem.png" />
                                    <WebProjectWindow title="Unity Serve" description="FullStack Development" img="../IMG/UnityServe.png" />
                                    <WebProjectWindow title="Venture Up" description="Frontend Development" img="../IMG/VentureUp.png" />
                                    <WebProjectWindow title="Weather Forecast" description="FullStack Development" img="../IMG/WeatherForecast.png" />
                                    <WebProjectWindow title="Firebase Login" description="FullStack Development" img="../IMG/FirebaseLogin.jpeg" />
                                    <XenithGoods />
                                    <BillingSystem />
                                    <UnityServe />
                                    <VentureUp />
                                    <WeatherForecast />
                                    <FirebaseLogin />
                                </>)}
                            </div>

                            <div className="All-Projects-App">
                                {isAppDevPage && (<>
                                    <AppProjectWindow title="Expense App" name={'BillBuddy'} description="App Development" tech={['React Native', 'Firebase']} />
                                    <AppProjectWindow title="Guess Game" name={'GuessGame'} description="App Development" tech={['React Native', 'Expo']} />
                                    <AppProjectWindow title="Ai Genius" name={'AiGenius'} description="App Development" tech={['React Native', 'Expo', 'OpenAI']} />
                                </>)}
                            </div>

                            <div className="All-Projects">
                                {isMLAiDevPage && (<>
                                    <MlAiProjectWindow title="Ai ChatBot" description="ML/AI Development" img="../IMG/AiChatBot.jpeg" />
                                    <MlAiProjectWindow title="SentimentSense - YouTube Sentiment & Toxicity Analyzer" description="ML/AI Development" img="../IMG/SentimentSense.png" />
                                    <MlAiProjectWindow title="FlappyBird" description="ML/AI & Game Development" img="../IMG/FlappyBird.jpg" />
                                    <MlAiProjectWindow title="Text Classification" description="ML/AI Development" img="../IMG/TextClassification.jpeg" />
                                    <MlAiProjectWindow title="TFOD-Gestures: Live Hand Gesture Recognition System" description="Deep Learning" img="../IMG/Realtime-TFOD.jpg" />
                                    <MlAiProjectWindow title="Real-Time Facial Recognition and Emotion Detection" description="ML/AI Development" img="../IMG/FacialRecognition.png" />
                                    <AiChatBot />
                                    <YoutubeAnalyzer />
                                    <FlappyBird />
                                    <TextClassification />
                                    <RealtimeTFOD />
                                    <FacialRecognition />
                                </>)}
                            </div>


                        </div>
                    </section>

                    <Exit />

                    <Helmet>
                        <script src='../Js/Projects.js'></script>
                        <script src='../Js/ProjectInfo.js'></script>
                    </Helmet>
                </>
            }
        </>
    )
}

export default Projects